'use client';

import Image from 'next/image';

interface FeaturesProps {
  translations: {
    feature1: {
      title: string;
      description: string;
    };
    feature2: {
      title: string;
      description: string;
    };
    feature3: {
      title: string;
      description: string;
    };
  };
}

export default function Features({ translations }: FeaturesProps) {
  return (
    <section className='section-container pb-0 md:pb-20 md:pt-16'>
      {/* Feature 1 */}
      <div className='mb-10 flex flex-col items-center justify-between gap-24 md:mb-24 md:flex-row'>
        <div className='w-full md:w-1/2'>
          <h2 className='mb-6 text-2xl font-semibold text-black md:text-3xl md:font-bold'>
            {translations.feature1.title}
          </h2>

          <div className='mb-6 block w-full md:hidden'>
            <div className='flex items-center justify-center'>
              <div className='relative'>
                <Image
                  src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/9b73d6da-7e94-4da9-1866-26807651e600/public'
                  alt='Feature 1'
                  width={600}
                  height={470}
                  className='h-auto w-full'
                />
              </div>
            </div>
          </div>

          <p className='mb-4 text-base text-[#252933] md:text-lg'>
            {translations.feature1.description}
          </p>
        </div>

        <div className='hidden w-full md:block md:w-1/2'>
          <div className='flex items-center justify-center'>
            <div className='relative'>
              <Image
                src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/9b73d6da-7e94-4da9-1866-26807651e600/public'
                alt='Feature 1'
                width={600}
                height={470}
                className='h-auto w-full max-w-full'
              />
            </div>
          </div>
        </div>
      </div>

      {/* Feature 2 */}
      <div className='mb-10 flex flex-col items-center justify-between gap-24 md:mb-24 md:flex-row-reverse'>
        <div className='w-full md:w-1/2'>
          <h2 className='mb-6 text-2xl font-semibold text-black md:text-3xl md:font-bold'>
            {translations.feature2.title}
          </h2>

          <div className='mb-6 block w-full md:hidden'>
            <div className='relative'>
              <Image
                src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/5f2bb3ee-8b02-40be-0e11-f7f8611be100/public'
                alt='Feature 2'
                width={600}
                height={500}
                className='h-auto w-full'
              />
            </div>
          </div>

          <p className='mb-4 text-base text-[#252933] md:text-lg'>
            {translations.feature2.description}
          </p>
        </div>

        <div className='hidden w-full md:block md:w-1/2'>
          <div className='relative'>
            <Image
              src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/5f2bb3ee-8b02-40be-0e11-f7f8611be100/public'
              alt='Feature 2'
              width={600}
              height={500}
              className='h-auto w-full max-w-full'
            />
          </div>
        </div>
      </div>

      {/* Feature 3 */}
      <div className='mb-10 flex flex-col items-center justify-between gap-24 md:mb-24 md:flex-row'>
        <div className='w-full md:w-1/2'>
          <h2 className='mb-6 text-2xl font-semibold text-black md:text-3xl md:font-bold'>
            {translations.feature3.title}
          </h2>

          <div className='mb-6 block w-full md:hidden'>
            <div className='flex items-center justify-center'>
              <Image
                src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/8612070a-bf1a-4adf-ce68-fa6813a58c00/public'
                alt='Feature 3'
                width={500}
                height={500}
                className='h-auto w-full'
              />
            </div>
          </div>

          <p className='mb-4 text-base text-[#252933] md:text-lg'>
            {translations.feature3.description}
          </p>
        </div>

        <div className='hidden w-full md:block md:w-1/2'>
          <div className='flex items-center justify-center'>
            <Image
              src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/8612070a-bf1a-4adf-ce68-fa6813a58c00/public'
              alt='Feature 3'
              width={500}
              height={500}
              className='h-auto w-full max-w-full'
            />
          </div>
        </div>
      </div>
    </section>
  );
}
